const orderBaseUrl = '/api/orderservice/proxy';

export const CREATE_ORDER_URL = orderBaseUrl + '/order/createorder';
export const CREATE_QUOTE_URL = orderBaseUrl + '/order/createquote';
export const GET_ADDRESSES_URL = orderBaseUrl + '/checkout/getaddresses';
export const GET_CONTACTS_URL = orderBaseUrl + '/checkout/getcontacts';
export const GET_CUSTOMER_URL = orderBaseUrl + '/checkout/GetCustomer';
export const RETRIEVE_PRICE_AND_STOCK_URL = orderBaseUrl + '/order/retrievepriceandstock';
